import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Image,
  Flex,
  Divider,
  Alert,
  Button,
  Layout,
  Skeleton,
  Tooltip,
} from "antd";
import {
  useOutletContext,
  Link,
  useNavigate,
  useLocation,
} from "react-router-dom";
import useActions from "./hooks/useActions";
import defaultImage from "../../../../../../../assets/images/png/general/img_thumb_default.png";
import { WarningFilled, ArrowLeftOutlined } from "@ant-design/icons";
import moment from "moment";
import "moment/dist/locale/id";
import Learningpoints from "../../../../../../../assets/images/svgs/ic_learningpoints_programdesc.svg";
import ic_infopoints_moduledesc from "../../../../../../../assets/images/svgs/ic_infopoints_moduledesc.svg";
import ic_badgelock_moduledesc from "../../../../../../../assets/images/svgs/ic_badgelock_moduledesc.svg";
import { useDispatch, useSelector } from "react-redux";

// color config
import {
  backgroundModuleWarning,
  textModuleWarning,
  colorTextTitle,
  colorTextDesc,
  whiteColor,
  colorTextTitleMobile,
  textTitleMyLearningJourney,
} from "../../../../../../../config/constant/color/index";

// for translate
import { useTranslation } from "react-i18next";

// import styles
import styles from "./styles";
// import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";

import {
  setIsPlay
} from "../../../../../../../redux/features/learning_journey/learningJourneySlice";


import { getLocalStorage, decryptDataModule } from "../../../../../../../utils";

const { Footer, Content } = Layout;

const Module = ({ isMobileVersion }) => {
  const dispatch = useDispatch();
  const reRenderMenu = useSelector((state) => state.localization.reRenderMenu);
  const backLoad = useSelector((state) => state.learning_journey.backLoad);

  const { t, i18n } = useTranslation();
  const localeDate = i18n.language === "en" ? "en" : "id";

  const [outletProps] = useOutletContext();
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [btnText, setBtnText] = useState("");
  const [moduleDesc, setModuleDesc] = useState("");
  const [infoWarning, setInfoWarning] = useState({
    text: "",
    color: "",
    background: "",
  });
  const [resyncBtn, setResyncBtn] = useState(false)
  const [ hideBtnEnter, setHideBtnEnter ] = useState(false)

  const {
    journeyId,
    courseId,
    moduleId,
    loadingLP,
    idxOpenedModule,
    hiddenClick,
    reFetchLeftSection,
    setHiddenClick,
    setModuleStream,
    setLinkStream,
    setIdxOpenedModule,
    mainState
  } = outletProps;

  const url = window.location.pathname;
  const arrId = url.split("/");
  const journeyIdPosition = arrId.indexOf("journey");
  const courseIdPosition = arrId.indexOf("course");
  const moduleIdPosition = arrId.indexOf("module");
  const moduleSupIdPosition = arrId.indexOf("supporting");
  const currentJourneyId = parseInt(arrId[journeyIdPosition + 1]);
  const currentCourseId = parseInt(arrId[courseIdPosition + 1]);
  const currentModuleId = parseInt(arrId[moduleIdPosition + 1]);
  const currentModuleSupId = parseInt(arrId[moduleSupIdPosition + 1]);

  const currModuleId = moduleId ? moduleId : currentModuleId;

  const alertMessage = (message, completed) => {
    return (
      <>
        {message}
        <br />
        {completed ? (
          <>
            <span style={styles.alertMessage}>
              {t("feature.feature_mylj.main_content.ask_to_unlock")}
            </span>
          </>
        ) : null}
      </>
    );
  };

  const { currModule, loadingModule, sendScormData, loadingSendScorm,
    requiredPermissions,
    setRequiredPermissions,
    grantedPermissions,
    setGrantedPermissions,
    requestCameraMic,
    requestCamera,
    requestMic } = useActions(
    loadingLP,
    journeyId,
    courseId,
    currModuleId,
    setModuleStream,
    setIdxOpenedModule,
    hiddenClick,
    setHiddenClick,
    setLinkStream,
    reFetchLeftSection,
    isMobileVersion,
    mainState,
    setResyncBtn,
    setBtnText,
    setInfoWarning,
    alertMessage,
    reRenderMenu
  );

  const isCamOrMicNotAllowed =
    (requiredPermissions.camera && !grantedPermissions.camera) ||
    (requiredPermissions.mic && !grantedPermissions.mic);


  const checkStatus = () => {
    if (currModule.isopen === 0) {
      // 'Locked-disabled'
      setBtnText(t("feature.feature_mylj.main_content.enter"));
      setBtnDisabled(true);
      setInfoWarning({
        text: alertMessage(
          t(
            "feature.feature_mylj.main_content.complete_previous_module_message",
          ),
          false,
        ),
        color: textModuleWarning,
        background: backgroundModuleWarning,
      });
      setResyncBtn(false);
    } else if(localStorage.getItem("scorm-"+currModule.id) !== null && localStorage.getItem("scorm-"+currModule.id) !== undefined){
      setBtnText("Re-sync");
      setBtnDisabled(false);
      setResyncBtn(true)
    } else {
      setResyncBtn(false);
      if (currModule.attempt_limit === 0) {
        // always enable
        // 'always play'
        if (currModule.total_attempt === 0) {
          // 'Enter-enable'
          setBtnText(t("feature.feature_mylj.main_content.enter"));
          setBtnDisabled(false);
        } else {
          // 'Reattempt-enable'
          setBtnText(t("feature.feature_mylj.main_content.enter"));
          setBtnDisabled(false);
        }
      } else {
        if (currModule.total_attempt < currModule.attempt_limit) {
          if (currModule.total_attempt === 0) {
            // 'Enter-enable'
            setBtnText(t("feature.feature_mylj.main_content.enter"));
            setBtnDisabled(false);
          } else {
            // 'Reattempt-enable'
            setBtnText(t("feature.feature_mylj.main_content.enter"));
            setBtnDisabled(false);
          }
        } else {
          // 'Reattempt-disabled'
          setBtnText(t("feature.feature_mylj.main_content.enter"));
          setBtnDisabled(true);
          setInfoWarning({
            text: alertMessage(
              t("feature.feature_mylj.main_content.module_locked_message"),
              true,
            ),
            color: textModuleWarning,
            background: backgroundModuleWarning,
          });
        }
      }
    }

    if(currModule.cmid == null){
      setHideBtnEnter(true)
    } else {
      setHideBtnEnter(false)
    }
  };

  const handlePermission = async (targetUrl) => {
    let camGranted = grantedPermissions.camera;
    let micGranted = grantedPermissions.mic;

    if (requiredPermissions.camera && requiredPermissions.mic) {
      const granted = await requestCameraMic();
      camGranted = granted;
      micGranted = granted;
    } 
    else if (requiredPermissions.camera) {
      camGranted = await requestCamera();
    } 
    else if (requiredPermissions.mic) {
      micGranted = await requestMic();
    }

    const allGranted =
      (!requiredPermissions.camera || camGranted) &&
      (!requiredPermissions.mic || micGranted);

    if (allGranted) {
        setGrantedPermissions({
          camera: camGranted,
          mic: micGranted,
      });
      navigate(targetUrl);
    } else {
      // 🔥 RESET BENAR
      setGrantedPermissions({
        camera: false,
        mic: false,
      });
    }
  };


  

  const convertEnter = (desc) => {
    const replacer = desc.replace(/(?:\r\n|\r|\n)/g, "\n");

    setModuleDesc(replacer);
  };

  const dateBadgesConvert = (data) => {
    return moment(data).locale(localeDate).format("DD MMM YYYY");
  };

  useEffect(() => {
    if (loadingModule === false && currModule.id === currModuleId) {
      convertEnter(currModule.description);
    }
  }, [loadingModule, currModule]);

  useEffect(() => {
    if (currModule.id === currModuleId) {
      // use timeout to sync with clearDataForm(scormLocalStorageKey) on stream scorm
      setTimeout(() => {
        checkStatus()
      }, 800);
      setTimeout(() => {
        console.log("ke rerender")
      }, 800);
    };
  }, [currModule, reRenderMenu]);

  console.log("currModule", currModule);

  // const screens = useBreakpoint();
  // const isMobileVersion = screens.xs;
  let navigate = useNavigate();
  let locationRouter = useLocation();
  const queryParams = new URLSearchParams(locationRouter.search);
  const hasParamFrom = queryParams.has("from");
  const pageFrom = hasParamFrom ? queryParams.get("from") : null;
  const hasParamSrc = queryParams.has("src");
  const valueSrc = hasParamSrc ? queryParams.get("src") : null;

  const handleBack = (e) => {
    e.preventDefault();
    if (pageFrom === "home") {
      navigate("/home");
    } else if (valueSrc) {
      navigate(`/my-learning-journey?search=${valueSrc}`);
    } else {
      navigate(`/my-learning-journey/journey/${journeyId}/course/${courseId}`);
      // location.reload();
    }
  };

  const reSyncSendDataScorm = (module_id) => {
    // data from modul id in url
    const rawDataDecrypt = decryptDataModule(getLocalStorage("scorm-"+module_id))  

    let validData = null;

    // Pastikan datanya berbentuk object dan punya key yang sesuai
    if (
      rawDataDecrypt &&
      typeof rawDataDecrypt === "object" &&
      rawDataDecrypt.key === "data_scorm_web" &&
      rawDataDecrypt.value !== null
    ) {
      validData = rawDataDecrypt;
    }

    // console.log(validData); 
    const emptyDataScorm = {
      key:"data_scorm_web",
      value:"[]"
    }

    sendScormData(validData != null ? rawDataDecrypt : emptyDataScorm, "scorm-"+module_id, `/my-learning-journey/journey/${journeyId}/course/${courseId}/module/${currModuleId}/play`)
  }

  return (
    <>
      <Layout
        style={isMobileVersion ? styles.layoutStyleMobile : styles.layoutStyle}
      >
        <Content
          // style={
          //   isMobileVersion ? styles.contentStyleMobile : styles.contentStyle
          // }
          style={{
            height: isMobileVersion ? (btnDisabled ? "80vh" : "87vh") : "100%",
            overflowY: "auto",
            overflowX: "hidden",
            flex: isMobileVersion && "unset",
            maxHeight: isMobileVersion ? '100%' : "calc(100vh - 80px)"
          }}
        >
          {!isMobileVersion ? (
            <div style={styles.contentWrapper}>
              <Row>
                <Col span={18} style={{ paddingRight: 40 }}>
                  <div className="w-100 m-auto">
                    <div className="w-100" style={styles.moduleCountWrapper}>
                      {loadingModule ? (
                        <Skeleton.Input
                          active
                          size={16}
                          style={styles.textModuleCountSkeleton}
                        />
                      ) : (
                        <>
                          {t("feature.feature_mylj.main_content.module_cap")}{" "}
                          {idxOpenedModule}
                        </>
                      )}
                    </div>
                    <div style={styles.moduleNameWrapper}>
                      {loadingModule ? (
                        <Skeleton.Input
                          active
                          size={24}
                          style={styles.textModuleNameSkeleton}
                        />
                      ) : (
                        currModule.fullname
                      )}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        marginBottom: 23,
                      }}
                    >
                      <div style={{ display: "flex" }}>
                        <img
                          src={Learningpoints}
                          style={{ width: 16, height: 16 }}
                          alt="Learning Points"
                        />
                      </div>
                      <div
                        style={{
                          fontSize: 14,
                          fontWeight: 500,
                          lineHeight: "normal",
                          color: colorTextTitle,
                          marginLeft: 6,
                        }}
                      >
                        {currModule.learning_point !== undefined &&
                        currModule.learning_point !== null
                          ? parseInt(currModule.learning_point)
                          : 0}{" "}
                        {t("feature.feature_mylj.main_content.points_only")}
                        &nbsp;
                        {
                          currModule.has_point === 1 && t("feature.feature_mylj.main_content.earned")
                        }
                      </div>
                      <div style={{ display: "flex", marginLeft: 6 }}>
                        {isMobileVersion ? (
                          <img
                            src={ic_infopoints_moduledesc}
                            style={{ width: 16, height: 16 }}
                            alt="Icon info points"
                          />
                        ) : (
                          <Tooltip
                            arrow={false}
                            placement="right"
                            title={
                              currModule.has_point === 1 ?
                                `${t(
                                "feature.feature_mylj.main_content.you_can_only_collect_points",
                              )} ${
                                currModule.get_point_on_first_attempt !==
                                  undefined &&
                                currModule.get_point_on_first_attempt !== null
                                  ? currModule.get_point_on_first_attempt
                                  : "null"
                              } ${t(
                                "feature.feature_mylj.main_content.desc_attempt",
                              )}`
                              :
                              `${t(
                                "feature.feature_mylj.main_content.this_module_no_point",
                              )}`
                            }
                          >
                            <img
                              src={ic_infopoints_moduledesc}
                              style={{ width: 16, height: 16 }}
                              alt="Icon info points"
                            />
                          </Tooltip>
                        )}
                      </div>
                    </div>
                    <Flex>
                      <Col style={styles.moduleSpecWrapper}>
                        {loadingModule ? (
                          <>
                            <div style={styles.moduleSpecRowOneSkel}>
                              <Skeleton.Input
                                active
                                size={18}
                                style={styles.inputSkeletonTop}
                              />
                              <Skeleton.Input
                                active
                                size={18}
                                style={styles.inputSkeletonBot}
                              />
                            </div>
                            <div style={styles.moduleSpecRowTwoSkel}>
                              <Skeleton.Input
                                active
                                size={18}
                                style={styles.inputSkeletonTop}
                              />
                              <Skeleton.Input
                                active
                                size={18}
                                style={styles.inputSkeletonBot}
                              />
                            </div>
                          </>
                        ) : (
                          <>
                            <table
                              style={styles.tableWidth}
                              className="module-desc-table"
                            >
                              <tbody>
                                <tr className="tr-top-table">
                                  <td style={styles.typeGradeWidth}>
                                    {t(
                                      "feature.feature_mylj.main_content.module_type",
                                    )}
                                  </td>
                                  <td>:&nbsp;</td>
                                  <td
                                    style={styles.colorToPrimary}
                                    className="pright-30"
                                  >
                                    {currModule.category !== undefined &&
                                    currModule.category !== "" &&
                                    currModule.category !== null ? (
                                      <>{currModule.category}</>
                                    ) : (
                                      <>-</>
                                    )}
                                  </td>
                                  <td style={styles.attemptWidth}>
                                    {t(
                                      "feature.feature_mylj.main_content.number_of_attempts",
                                    )}
                                  </td>
                                  <td>:&nbsp;</td>
                                  <td style={styles.colorToPrimary}>
                                    {currModule.total_attempt}
                                  </td>
                                </tr>
                                <tr>
                                  <td style={styles.typeGradeWidth}>
                                    {t(
                                      "feature.feature_mylj.main_content.grading_method",
                                    )}
                                  </td>
                                  <td>:&nbsp;</td>
                                  <td
                                    style={styles.colorToPrimary}
                                    className="pright-30"
                                  >
                                    {t(
                                      "feature.feature_mylj.main_content.highest_score",
                                    )}
                                  </td>
                                  <td>
                                    {t(
                                      "feature.feature_mylj.main_content.attempt_limit",
                                    )}
                                  </td>
                                  <td>:&nbsp;</td>
                                  <td style={styles.colorToPrimary}>
                                    {currModule.attempt_limit > 0 ? (
                                      currModule.attempt_limit
                                    ) : (
                                      <>
                                        {t(
                                          "feature.feature_mylj.main_content.unlimited",
                                        )}
                                      </>
                                    )}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </>
                        )}
                      </Col>
                    </Flex>
                  </div>

                  <Divider style={styles.divider} />

                  <div className="w-100" style={styles.moduleDescWrapper}>
                    {loadingModule ? (
                      <Skeleton paragraph={{ rows: 10 }} active />
                    ) : (
                      moduleDesc
                    )}
                  </div>
                </Col>
                <Col span={6}>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <div
                      className="w-100"
                      style={styles.moduleCountWrapperHide}
                    >
                      {t("feature.feature_mylj.main_content.module_cap")}{" "}
                      {idxOpenedModule}
                    </div>
                    <div style={styles.imageThumbnailWrapper}>
                      {loadingModule ? (
                        <Skeleton.Avatar
                          active
                          shape="square"
                          style={styles.avatarThumbnailSkeleton}
                        />
                      ) : (
                        <Image
                          width={200}
                          height={135}
                          style={styles.imageThumbnail}
                          src={currModule.thumbnail}
                          preview={false}
                          fallback={defaultImage}
                          alt="Module Thumbnail"
                        />
                      )}
                    </div>
                    <div
                      style={{
                        display:
                          currModule.has_badges !== undefined &&
                          currModule.has_badges !== 0
                            ? "flex"
                            : "none",
                        flexDirection: "row",
                        alignItems: "center",
                        minWidth: 200,
                      }}
                    >
                      <div>
                        <img
                          src={
                            currModule.badge_thumbnail !== undefined &&
                            currModule.badge_thumbnail !== ""
                              ? currModule.badge_thumbnail
                              : ic_badgelock_moduledesc
                          }
                          style={{ width: 64 }}
                          alt="Icon badge lock"
                        />
                      </div>
                      <div
                        style={{
                          marginLeft: 8,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                          justifyContent: "center",
                        }}
                      >
                        <div
                          style={{
                            fontSize: 14,
                            fontWeight: 500,
                            color: colorTextTitle,
                            marginBottom: 4,
                          }}
                        >
                          {currModule.badge_name !== undefined &&
                          currModule.badge_name !== ""
                            ? currModule.badge_name
                            : ""}
                        </div>
                        <div style={{ fontSize: 12, color: colorTextDesc }}>
                          {currModule.earn_badges_on !== undefined &&
                          currModule.earn_badges_on !== "" ? (
                            <>
                              {t("feature.feature_mylj.main_content.earned_on")}{" "}
                              {dateBadgesConvert(currModule.earn_badges_on)}
                            </>
                          ) : (
                            <>
                              {t(
                                "feature.feature_mylj.main_content.complete_module_to_get_badge",
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          ) : (
            <div style={{ margin: "0px" }}>
              <Flex style={{ display: "flex", flexDirection: "column" }}>
                <Row
                  className="row-image"
                  style={{
                    width: "100%",
                    height: "100%",
                  }}
                >
                  {loadingModule ? (
                    // <Skeleton.Avatar
                    //   active
                    //   shape="square"
                    //   style={{
                    //     width: "350px",
                    //     height: "113px",
                    //     borderRadius: "8px",
                    //   }}
                    // />
                    <Skeleton.Avatar
                      active
                      shape="square"
                      style={{
                        width: "99vw",
                        height: "160px",
                        borderRadius: "8px",
                      }}
                    />
                  ) : (
                    <Image
                      width={"100%"}
                      height={"100%"}
                      style={{
                        objectFit: "fill",
                        height: "100%",
                      }}
                      src={currModule?.thumbnail}
                      preview={false}
                      fallback={defaultImage}
                      alt="Modul Thumbnail Mobile"
                    />
                  )}
                  <div
                    className="btn-back-mobile"
                    style={{
                      position: "absolute",
                      top: "20px",
                      left: "18px",
                      cursor: "pointer",
                      borderRadius: "50%",
                      width: "40px",
                      height: "40px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: whiteColor,
                      boxShadow: "0px 3px 6px 0px rgba(0, 0, 0, 0.18)",
                    }}
                    onClick={(e) => handleBack(e)}
                  >
                    <ArrowLeftOutlined
                      style={{
                        color: colorTextTitleMobile,
                        width: "15px",
                        height: "15px",
                      }}
                    />
                  </div>
                </Row>
                <div
                  className="div-right"
                  style={{
                    alignSelf: "center",
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    padding: "20px 18px",
                    height: "160px",
                  }}
                >
                  {loadingModule ? (
                    <Skeleton.Input
                      active
                      size={16}
                      style={{ marginBottom: "10px", minWidth: "70px" }}
                    />
                  ) : (
                    <p
                      className="p-module"
                      style={{
                        fontSize: "10px",
                        marginBottom: "10px",
                        fontWeight: "400",
                        color: colorTextDesc,
                      }}
                    >
                      {t("feature.feature_mylj.main_content.module_cap")}{" "}
                      {idxOpenedModule}
                    </p>
                  )}
                  <Row>
                    {loadingModule ? (
                      <Skeleton.Input
                        active
                        size={22}
                        style={{
                          marginRight: "8px",
                          minWidth: "300px",
                          marginBottom: "8px",
                        }}
                      />
                    ) : (
                      <span
                        className="title-module-desc"
                        style={{
                          fontSize: "18px",
                          fontWeight: "500",
                          marginBottom: "8px",
                          color: colorTextTitleMobile,
                        }}
                      >
                        {currModule?.fullname}
                      </span>
                    )}
                  </Row>
                  <Row style={{ marginBottom: 16, flexDirection: "column" }}>
                    {loadingModule ? (
                      <Skeleton.Input
                        active
                        size={22}
                        style={{
                          marginRight: "8px",
                          minWidth: "100px",
                          marginBottom: "8px",
                        }}
                      />
                    ) : (
                      <>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "flex-start",
                          }}
                        >
                          <div style={{ display: "flex" }}>
                            <img
                              src={Learningpoints}
                              style={{ width: 16, height: 16 }}
                              alt="Learning Points"
                            />
                          </div>
                          <div
                            style={{
                              fontSize: 12,
                              fontWeight: 500,
                              lineHeight: "normal",
                              color: colorTextTitle,
                              marginLeft: 6,
                            }}
                          >
                            {currModule?.learning_point !== undefined &&
                            currModule?.learning_point !== null
                              ? parseInt(currModule?.learning_point)
                              : 0}{" "}
                            {t(
                              "feature.feature_mylj.main_content.points_earned",
                            )}
                          </div>
                        </div>
                        <span
                          style={{
                            fontSize: "10px",
                            fontWeight: 400,
                            color: colorTextDesc,
                            marginLeft: 22,
                          }}
                        >
                          {`${t(
                            "feature.feature_mylj.main_content.you_can_only_collect_points",
                          )} ${
                            currModule.get_point_on_first_attempt !==
                              undefined &&
                            currModule.get_point_on_first_attempt !== null
                              ? currModule.get_point_on_first_attempt
                              : "null"
                          } ${t(
                            "feature.feature_mylj.main_content.desc_attempt",
                          )}`}
                        </span>
                      </>
                    )}
                  </Row>

                  <Flex style={{ marginBottom: 16 }}>
                    <Col
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      {loadingModule ? (
                        <>
                          <div style={styles.moduleSpecRowOneSkel}>
                            <Skeleton.Input
                              active
                              size={18}
                              style={styles.inputSkeletonTop}
                            />
                            <Skeleton.Input
                              active
                              size={18}
                              style={styles.inputSkeletonBot}
                            />
                          </div>
                          <div style={styles.moduleSpecRowTwoSkel}>
                            <Skeleton.Input
                              active
                              size={18}
                              style={styles.inputSkeletonTop}
                            />
                            <Skeleton.Input
                              active
                              size={18}
                              style={styles.inputSkeletonBot}
                            />
                          </div>
                        </>
                      ) : (
                        <>
                          <table
                            style={styles.tableWidth}
                            className="module-desc-table"
                          >
                            <tbody>
                              <tr>
                                <td style={styles.tableRowCustom}>
                                  {t(
                                    "feature.feature_mylj.main_content.module_type",
                                  )}
                                </td>
                                <td
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: "400",
                                    color: colorTextDesc,
                                    paddingBottom: "6px",
                                    paddingLeft: "4px",
                                  }}
                                >
                                  :&nbsp;
                                </td>
                                <td style={styles.colorToPrimaryMobile}>
                                  {currModule?.category !== undefined &&
                                  currModule?.category !== "" &&
                                  currModule?.category !== null ? (
                                    <>{currModule?.category}</>
                                  ) : (
                                    <>-</>
                                  )}
                                </td>
                              </tr>
                              <tr style={styles.tableRowCustom}>
                                <td>
                                  {t(
                                    "feature.feature_mylj.main_content.number_of_attempts",
                                  )}
                                </td>
                                <td
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: "400",
                                    color: colorTextDesc,
                                    paddingBottom: "6px",
                                    paddingLeft: "4px",
                                  }}
                                >
                                  :&nbsp;
                                </td>
                                <td style={styles.colorToPrimaryMobile}>
                                  {currModule?.total_attempt}
                                </td>
                              </tr>
                              <tr style={styles.tableRowCustom}>
                                <td>
                                  {t(
                                    "feature.feature_mylj.main_content.grading_method",
                                  )}
                                </td>
                                <td
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: "400",
                                    color: colorTextDesc,
                                    paddingBottom: "6px",
                                    paddingLeft: "4px",
                                  }}
                                >
                                  :&nbsp;
                                </td>
                                <td style={styles.colorToPrimaryMobile}>
                                  {t(
                                    "feature.feature_mylj.main_content.highest_score",
                                  )}
                                </td>
                              </tr>
                              <tr style={styles.tableRowCustom}>
                                <td>
                                  {t(
                                    "feature.feature_mylj.main_content.attempt_limit",
                                  )}
                                </td>
                                <td
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: "400",
                                    color: colorTextDesc,
                                    paddingBottom: "6px",
                                    paddingLeft: "4px",
                                  }}
                                >
                                  :&nbsp;
                                </td>
                                <td style={styles.colorToPrimaryMobile}>
                                  {currModule?.attempt_limit > 0 ? (
                                    currModule?.attempt_limit
                                  ) : (
                                    <>
                                      {t(
                                        "feature.feature_mylj.main_content.unlimited",
                                      )}
                                    </>
                                  )}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </>
                      )}

                      <Row
                        style={{
                          width: "30%",
                          justifyContent: "end",
                          display:
                            currModule?.has_badges !== undefined &&
                            currModule?.has_badges !== 0
                              ? "flex"
                              : "none",
                        }}
                      >
                        <div
                          style={{
                            display:
                              currModule?.has_badges !== undefined &&
                              currModule?.has_badges !== 0
                                ? "flex"
                                : "none",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <div>
                            <img
                              src={
                                currModule?.badge_thumbnail !== undefined &&
                                currModule?.badge_thumbnail !== ""
                                  ? currModule?.badge_thumbnail
                                  : ic_badgelock_moduledesc
                              }
                              style={{ width: 64 }}
                              alt="Icon badge lock"
                            />
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "flex-start",
                              justifyContent: "center",
                              marginTop: "4px",
                            }}
                          >
                            {/* <div
                              style={{
                                fontSize: 14,
                                fontWeight: 500,
                                color: colorTextDesc,
                                marginBottom: 4,
                                textAlign: "center",
                              }}
                            >
                              {currModule.badge_name !== undefined &&
                              currModule.badge_name !== ""
                                ? currModule.badge_name
                                : ""}
                            </div> */}
                            <div
                              style={{
                                fontSize: 12,
                                color: colorTextDesc,
                                textAlign: "center",
                                display: "flex",
                                flexDirection: "column",
                                gap: "2px",
                              }}
                            >
                              {currModule?.earn_badges_on !== undefined &&
                              currModule?.earn_badges_on !== "" ? (
                                <>
                                  <span
                                    style={{
                                      fontSize: "10px",
                                      fontWeight: "400",
                                      color: "#67686D",
                                    }}
                                  >
                                    {t(
                                      "feature.feature_mylj.main_content.earned_on",
                                    )}
                                  </span>
                                  <span
                                    style={{
                                      fontSize: "10px",
                                      fontWeight: "500",
                                      color: "#212121",
                                    }}
                                  >
                                    {dateBadgesConvert(
                                      currModule?.earn_badges_on,
                                    )}
                                  </span>
                                </>
                              ) : (
                                <span
                                  style={{
                                    fontSize: "10px",
                                    fontWeight: "500",
                                    color: "#67686D",
                                  }}
                                >
                                  {t(
                                    "feature.feature_mylj.main_content.complete_module_to_get_badge",
                                  )}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </Row>
                    </Col>
                  </Flex>

                  <Row>
                    <div
                      className="w-100"
                      style={styles.moduleDescWrapperMobile}
                    >
                      {loadingModule ? (
                        <Skeleton paragraph={{ rows: 10 }} active />
                      ) : (
                        moduleDesc
                      )}
                    </div>
                  </Row>
                </div>
              </Flex>
            </div>
          )}
        </Content>
        <Footer style={isMobileVersion ? styles.footerMobile : currModule.total_attempt < currModule.attempt_limit ? styles.footer : styles.footerHeightAuto}>
          <Row justify={"space-between"}>
            <Col
              span={isMobileVersion ? 24 : 18}
              style={
                isMobileVersion
                  ? styles.alertMessageWrapperMobile
                  : styles.alertMessageWrapper
              }
            >
              {(btnDisabled || isCamOrMicNotAllowed) && (
                <Alert
                  type="error"
                  showIcon
                  icon={<WarningFilled style={{ color: infoWarning.color }} />}
                  style={{
                    border: "none",
                    width: isMobileVersion ? "100%" : "fit-content",
                    color: infoWarning.color,
                    justifyContent: isMobileVersion ? "center" : "flex-start",
                  }}
                  message={infoWarning.text}
                  className={isMobileVersion ? "alert-message-mobile" : "alert-message"}
                />
              )}
            </Col>
            <Col span={isMobileVersion ? 24 : 6} style={styles.buttonWrapper}>
              {
              hideBtnEnter ? <></>
              :
              btnDisabled ? (
                <>
                  <Button
                    className="btn btn-primary btn-block enter-module-disabled"
                    style={
                      isMobileVersion
                        ? styles.buttonStyleMobile
                        : styles.buttonStyle
                    }
                    onChange={() => {}}
                  >
                    {btnText}
                  </Button>
                </>
              ) : resyncBtn ? (
                <>
                  <Button
                      className="btn btn-primary btn-block btn-resync"
                      style={{
                        backgroundColor:"red",
                        fontWeight: "500",
                        maxWidth: isMobileVersion ? "100%" : "200px",
                        height: "40px",
                        borderRadius: "6px",
                      }}
                      onClick={() => reSyncSendDataScorm(currModuleId)}
                      loading={loadingSendScorm}
                    >
                      {btnText}
                    </Button>
                </>
              ):(
                <>
                  {/* <Link
                    to={`/my-learning-journey/journey/${journeyId}/course/${courseId}/module/${currModuleId}/play`}
                  > */}
                    <Button
                      className="btn btn-primary btn-block"
                      style={
                        isMobileVersion
                          ? styles.buttonStyleMobile
                          : styles.buttonStyle
                      }
                      onChange={() => {}}
                      onClick={() => {
                        dispatch(setIsPlay(true));
                        handlePermission(`/my-learning-journey/journey/${journeyId}/course/${courseId}/module/${currModuleId}/play`);
                      }}
                    >
                      {
                        backLoad ? "Enter" : btnText
                      }
                    </Button>
                  {/* </Link> */}
                </>
              )}
            </Col>
          </Row>
        </Footer>
      </Layout>
    </>
  );
};

export default Module;
